module.exports = __webpack_public_path__ + "static/img/3.dc962a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/management/3.png
// module id = abZU
// module chunks = 7